import React, { useContext } from "react";
import homeaboutus from "../photos/aboutus.png";
import "./homeaboutus.css";
import { GoArrowRight } from "react-icons/go";
import { NavLink } from "react-router-dom";
import { LanguageContext } from "../settings/LanguageContext";

const Homeaboutus = () => {
  const { lang } = useContext(LanguageContext);

  return (
    <div className="main-homeaboutus">
      <div className="homeaboutus">
        <div className="aboutustext-btns">
          <h1 className="aboutus-title">
            {lang === "EN" ? "About Us" : "О нас"}
          </h1>

          <p className="about-us-text">
            {lang === "EN" ? (
              <>
                Founded in 2018, Memory Maker Travel specializes in private and group tours across Armenia, delivering exceptional travel experiences that combine cultural richness, historic sites, and breathtaking landscapes.
Our team comprises dedicated professionals with extensive experience in travel and hospitality. We are committed to providing seamless, well-planned journeys, ensuring every detail is carefully managed for your comfort and enjoyment.
At Memory Maker Travel, our guiding principle is simple: we treat our guests the way we would want to be treated when traveling abroad. This philosophy shapes every tour we create, offering personalized service, genuine care, and a deep respect for our clients.
With a focus on professionalism, reliability, and authentic experiences, we strive to make every trip memorable, enriching, and truly exceptional.`
              </>
            ) : (
              <>
                Основанная в 2018 году, Memory Maker Travel специализируется на индивидуальных и групповых турах по Армения, предлагая исключительные туристические впечатления, сочетающие культурное богатство, исторические достопримечательности и захватывающие природные пейзажи.
Наша команда состоит из преданных своему делу профессионалов с обширным опытом работы в сфере туризма и гостеприимства. Мы стремимся обеспечивать комфортные и тщательно организованные путешествия, уделяя внимание каждой детали для вашего удобства и удовольствия.
В Memory Maker Travel наш основной принцип прост: мы относимся к нашим гостям так, как хотели бы, чтобы относились к нам во время путешествий за границей. Эта философия лежит в основе каждого создаваемого нами тура, предлагая персонализированный сервис, искреннюю заботу и глубокое уважение к нашим клиентам.
Сосредоточившись на профессионализме, надежности и подлинных впечатлениях, мы стремимся сделать каждую поездку запоминающейся, насыщенной и по-настоящему исключительной.
              </>
            )}
          </p>

          <div className="aboyt-text-dec-del">
            <NavLink to="/about#our-team">
              <button className="our-linkbutton">
                {lang === "EN" ? "Our Team" : "Наша команда"}
              </button>
            </NavLink>

            <span className="separator">/</span>

            <NavLink to="/about#our-vehicles">
              <button className="our-linkbutton">
                {lang === "EN" ? "Our Vehicles" : "Наш транспорт"}
              </button>
            </NavLink>
            <NavLink to="/about">
            <div className="seemore">
              {lang === "EN" ? "see more" : "смотреть больше"}{" "}
              <div className="seemore-btn">
                <GoArrowRight className="seemore-icon" />
              </div>
            </div>
</NavLink>
          </div>
        </div>

        <div className="pic">
          <img src={homeaboutus} alt="aboutus" />
        </div>
      </div>
    </div>
  );
};

export default Homeaboutus;
